export const FETCH_OFFER_PDF_REQUEST = 'CONFIGURATOR/OFFERS/FETCH_PDF_REQUEST';
export const FETCH_OFFER_PDF_SUCCESS = 'CONFIGURATOR/OFFERS/FETCH_PDF_SUCCESS';
export const FETCH_OFFER_PDF_FAILURE = 'CONFIGURATOR/OFFERS/FETCH_PDF_FAILURE';
